import { render } from "./Error404.vue?vue&type=template&id=dd33b52c"
import script from "./Error404.vue?vue&type=script&lang=ts"
export * from "./Error404.vue?vue&type=script&lang=ts"
script.render = render

export default script